import { call, takeLatest } from 'redux-saga/effects'

import { saveUserMeta } from 'helpers/utils'
import { UPDATE_LAYOUT } from './constants'

function* updateLayoutWorker(action) {
  yield call(saveUserMeta, 'layout', action.layout)
}

export default function* watcher() {
  yield takeLatest(UPDATE_LAYOUT, updateLayoutWorker)
}
